import styled from '@emotion/styled';

export const LpBox = styled.div`
  background-color: #fff;
  padding: 38px 41px;
  border: 1px solid #e7e7e7;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  border-radius: 4px;
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const SpinnerWrapper = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavBackLink = styled.div`
  padding: 40px 0px 20px 50px;

  a {
    color: var(--lp-colors-medium-blue-600);
    font-size: 15px;
    font-weight: 300;
    text-decoration: none;
    &:hover {
      text-decoration: none;
      color: var(--lp-colors-medium-blue-800);
    }
`;
